import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import { useAppLogic } from "./AppLogic";
import Footer from "./components/Footer";

function AppContent() {
  const {
    renderMainComponent,
    headerProps,
    sidebarProps,
    footerProps,
    isMenuOpened,
    colors,
  } = useAppLogic();

  return (
    <div className="app-wrapper" style={{ backgroundColor: colors.background }}>
      <div className="app-content">
        <Header data={headerProps} />
        <div className="main-content">
          <div className={`main-wrapper ${isMenuOpened ? "open" : ""}`}>
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={renderMainComponent()} />
              <Route path="/idea-validator" element={renderMainComponent()} />
              <Route path="/market-insights" element={renderMainComponent()} />
              <Route path="/pitch-deck" element={renderMainComponent()} />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </div>
          <div className={`sidebar-wrapper ${isMenuOpened ? "open" : ""}`}>
            <Sidebar data={sidebarProps} />
          </div>
        </div>
        <Footer data={footerProps} />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
